jQuery(document).ready(function() {
    jQuery('#slide-wrapper').multiscroll({
    	anchors: ['first', 'second', 'third', 'fourth'],
    	scrollingSpeed: 2000,
    	menu: '#menu',
    	css3: true
    });
});
